import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { LuggageSize, LuggageSizes } from 'src/app/models/LuggageSize.model';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';
import { LuggageType } from 'src/app/models/luggageType.model';
import { LuggageSizeData } from './LuggageSizeData.mode';
import { CloneService } from 'src/app/services/clone.service';

@Component({
  selector: 'app-luggage-size',
  templateUrl: './luggage-size.component.html',
  styleUrls: ['./luggage-size.component.scss']
})
export class LuggageSizeComponent implements OnInit {
  @Input('form') parentForm: FormGroup;
  @Input('data') data: LuggageSize;
  @Input('colHeaders') colHeaders: LuggageType[];
  @Input('isEditable') isEditable: boolean;

  gridData: GridData = new GridData();
  form: FormGroup;
  lascCtrl;
  matrix: LuggageSizeData[] = [];

  constructor(private _formBuilder: FormBuilder, private cloneService: CloneService) { }

  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('luggageSize', this._formBuilder.array([]));
    this.form.setControl('luggageSize', this.asFormGroup(this.data));
    this.lascCtrl = this.form.get('luggageSize').get('luggageSizeList');
    this.data.luggageSizeList = this.lascCtrl.value as LuggageSizes[];
    this.gridData = this.ConvertData();
  }
  

  asFormGroup(o: LuggageSize): FormGroup {
    const fg = new FormGroup({
      // luggageSizeId: new FormControl(o.id, Validators.required),
      luggageSizeList: new FormControl(o.luggageSizeList, Validators.required),
    });
    return fg;
  }

  ConvertData(): GridData {
    for (let i = 0; i < this.data.luggageSizeList.length; i++) {
      const element = this.data.luggageSizeList[i];
      let temp: LuggageSizeData = new LuggageSizeData();
      temp.value = element.x;
      temp.luggageSizeColId = element.luggageTypeId + 1;
      temp.luggageSizeRowId = 1;
      temp.luggageSizeId = element.luggageSizeId;
      this.matrix.push(temp);
    }
    for (let i = 0; i < this.data.luggageSizeList.length; i++) {
      const element = this.data.luggageSizeList[i];
      let temp: LuggageSizeData = new LuggageSizeData();
      temp.value = element.y;
      temp.luggageSizeColId = element.luggageTypeId + 1;
      temp.luggageSizeRowId = 2;
      temp.luggageSizeId = element.luggageSizeId;
      this.matrix.push(temp);
    }
    for (let i = 0; i < this.data.luggageSizeList.length; i++) {
      const element = this.data.luggageSizeList[i];
      let temp: LuggageSizeData = new LuggageSizeData();
      temp.value = element.z;
      temp.luggageSizeColId = element.luggageTypeId + 1;
      temp.luggageSizeRowId = 3;
      temp.luggageSizeId = element.luggageSizeId;
      this.matrix.push(temp);
    }
    let rowHeaders: IdValue[] = [];
    rowHeaders.push(new IdValue(1, 'X'));
    rowHeaders.push(new IdValue(2, 'Y'));
    rowHeaders.push(new IdValue(3, 'Z'));

    let colHeaders: IdValue[] = [];
    for (let i = 0; i < this.colHeaders.length; i++) {
      const headerEntry = this.colHeaders[i];
      colHeaders.push(new IdValue(headerEntry.id + 1, headerEntry.name));
    }
    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.matrix;
    grid.colProp = 'luggageSizeColId';
    grid.rowProp = 'luggageSizeRowId';
    grid.switchColWithRow = false;
    return grid;
  }
  ConvertDataBack(temp: LuggageSizeData[]) {

    let LuggageSizeValues: LuggageSizes[] = [];
    for (let j = 0; j < this.colHeaders.length; j++) {
      const element1 = this.colHeaders[j];      
      let tmpList: LuggageSizeData[] = [];

      for (let i = 0; i < temp.length; i++) {
        const element2 = temp[i];
        if (element1.id + 1 === element2.luggageSizeColId) {
          tmpList.push(element2);
        }
      }

      let size: LuggageSizes = new LuggageSizes();
      size.x = tmpList.find(v => v.luggageSizeRowId === 1).value;
      size.y = tmpList.find(v => v.luggageSizeRowId === 2).value;
      size.z = tmpList.find(v => v.luggageSizeRowId === 3).value;
      size.luggageSizeId = tmpList.find(v => v).luggageSizeId;
      size.luggageTypeId = element1.id;    
      
      LuggageSizeValues.push(size);
    }

    this.data.luggageSizeList = LuggageSizeValues;
  }
  save() {
    let clonedGridData = this.cloneService.deepClone(this.gridData.matrix) as LuggageSizeData[];
    this.ConvertDataBack(clonedGridData);
    if (this.lascCtrl !== null) {
      this.lascCtrl.patchValue(this.data.luggageSizeList);
    }
  }
}
